import { Base, createApp } from '@studiometa/js-toolkit';
import { Slider } from '@studiometa/ui';
import Header from './components/Header/index.js';
import GorgiasChatButton from './components/GorgiasChatButton.js';

/**
 * App
 */
class App extends Base {
  /**
   * App Configuration
   */
  static config = {
    name: 'App',
    components: {
      Header,
      Slider,
      GorgiasChatButton,
    },
  };
}

export default createApp(App, document.documentElement);
